export default [
  {
    path: 'create-external-training',
    name: 'createExternalTraining',
    component: () => import('@/views/Training/ExternalTraining/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-trainings',
      template: 'auth',
    },
  },
  {
    path: 'update-externa-training/:trainingId',
    name: 'updateExternalTraining',
    component: () => import('@/views/Training/ExternalTraining/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-trainings',
      template: 'auth',
    },
  },
  {
    path: 'update-externa-training-version/:trainingId/:versionId',
    name: 'updateExternalTrainingVersion',
    component: () => import('@/views/Training/ExternalTraining/CurrentVersionUpdate.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-trainings',
      template: 'auth',
    },
  },
  {
    path: 'create-internal-training/:templateId',
    name: 'createnternalTraining',
    component: () => import('@/views/Training/InternalTraining/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-trainings',
      template: 'auth',
    },
  },
  {
    path: 'update-internal-training/:trainingId',
    name: 'updateInternalTraining',
    component: () => import('@/views/Training/InternalTraining/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-trainings',
      template: 'auth',
    },
  },
  {
    path: 'create-internal-training-group',
    name: 'createInternalTrainingGroup',
    component: () => import('@/views/Training/InternalTraining/Group/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-trainings',
      template: 'auth',
    },
  },
  {
    path: 'internal-training-group/:id',
    name: 'internalTrainingGroup',
    component: () => import('@/views/Training/InternalTraining/Group/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-trainings',
      template: 'auth',
    },
  },
  {
    path: 'update-internal-training-group/:id',
    name: 'updateInternalTrainingGroup',
    component: () => import('@/views/Training/InternalTraining/Group/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-trainings',
      template: 'auth',
    },
  },
  {
    path: 'printing/training',
    name: 'PrintingTraining',
    component: () => import('@/views/Printing/Training.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'printing-training',
      template: 'printing',
    },
  },
  {
    path: 'trainings',
    name: 'trainings',
    component: () => import('@/views/Training/Index.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-training',
      template: 'auth',
    },
  },
  {
    path: 'external-training-content/:trainingId',
    name: 'externalTrainingContent',
    component: () => import('@/views/Training/ExternalTraining/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-training',
      template: 'auth',
    },
  },
  {
    path: 'external-training-create',
    name: 'externalTrainingCreate',
    component: () => import('@/views/Training/ExternalTraining/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-training',
      template: 'auth',
    },
  },
  {
    path: 'external-training-update-basic/:trainingId',
    name: 'externalTrainingUpdate',
    component: () => import('@/views/Training/ExternalTraining/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-training',
      template: 'auth',
    },
  },
  {
    path: 'external-training/:trainingId/external-training-update-version/:versionId',
    name: 'externalTrainingUpdateVersion',
    component: () => import('@/views/Training/ExternalTraining/CurrentVersionUpdate.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-training',
      template: 'auth',
    },
  },
  {
    path: 'internal-training-content/:trainingId',
    name: 'internalTrainingContent',
    component: () => import('@/views/Training/InternalTraining/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-training',
      template: 'auth',
    },
  },
  {
    path: 'internal-training-create/:templateId',
    name: 'internalTrainingCreate',
    component: () => import('@/views/Training/InternalTraining/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-training',
      template: 'auth',
    },
  },
  {
    path: 'internal-training-update/:trainingId',
    name: 'internalTrainingUpdate',
    component: () => import('@/views/Training/InternalTraining/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-training',
      template: 'auth',
    },
  },
  {
    path: 'internal-training-template-content/:templateId',
    name: 'internalTrainingTemplateContent',
    component: () => import('@/views/Training/InternalTraining/ShowTemplate.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-training',
      template: 'auth',
    },
  },
  {
    path: 'internal-training-group-create',
    name: 'internalTrainingGroupCreate',
    component: () => import('@/views/Training/InternalTraining/Group/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-training',
      template: 'auth',
    },
  },
  {
    path: 'internal-training-group-content/:id',
    name: 'internalTrainingGroupContent',
    component: () => import('@/views/Training/InternalTraining/Group/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-training',
      template: 'auth',
    },
  },
  {
    path: 'internal-training-group-update/:id',
    name: 'internalTrainingGroupUpdate',
    component: () => import('@/views/Training/InternalTraining/Group/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-training',
      template: 'auth',
    },
  },
  {
    path: 'print-training',
    name: 'printTraining',
    component: () => import('@/views/Printing/Training.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'printing-training',
      template: 'printing',
    },
  },
];
